/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_4_QuestionInputs */

const en_svc_n8n_faq_4_question = /** @type {(inputs: Svc_N8n_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can n8n workflows use AI models?`)
};

const lv_svc_n8n_faq_4_question = /** @type {(inputs: Svc_N8n_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai n8n darba plūsmas var izmantot AI modeļus?`)
};

/**
* | output |
* | --- |
* | "Can n8n workflows use AI models?" |
*
* @param {Svc_N8n_Faq_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_4_question = /** @type {((inputs?: Svc_N8n_Faq_4_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_4_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_4_question(inputs)
	return en_svc_n8n_faq_4_question(inputs)
});